import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {AppComponent} from './app.component';
import {AppRoutes} from './app.routes';
import {
    AppInterceptor,
    HbsServicesModule,
    Level as LoggerLevel,
    LoggerService,
    Options as LoggerOptions
} from './modules/hbs-services';
import {environment} from '../environments/environment';
import {HomeComponent} from './home.component';
import {HbsPageItemsModule} from './modules/hbs-pageItems';
import {HbsComponentsModule} from './modules/hbs-components';
import {WowModule} from './modules/wow/wow.module';

import {MDBBootstrapModulesPro, MDBSpinningPreloader, ToastModule} from 'ng-uikit-pro-standard';

import { FilterPipeModule } from 'ngx-filter-pipe';
import {DevToolsExtension, NgRedux, NgReduxModule} from '@angular-redux/store';
import {createEpicMiddleware} from 'redux-observable';
import {SweetAlert2Module} from '@toverux/ngx-sweetalert2';
import {StorageModule} from './modules/storage/storage.module';
import {AppStorageState, initialState, rootReducer} from './modules/storage';
import {RootEpic} from './modules/storage/epics/root.epic';
import {DeviceDetectorModule} from 'ngx-device-detector';

const IS_PROD = environment.production;

/**
 * Read this https://redux-observable.js.org/ to understand more about usage of redux-observable in redux/store
 */

@NgModule({

    /* IMPORTS are needed by component templates declared in this module */
    imports: [CommonModule, FormsModule, ReactiveFormsModule,

        BrowserModule, BrowserAnimationsModule, HttpClientModule,
        RouterModule.forRoot(AppRoutes),

        NgReduxModule,

        ToastModule.forRoot(),
        MDBBootstrapModulesPro.forRoot(),
        HbsServicesModule.forRoot(),
        StorageModule.forRoot(),

        FilterPipeModule,

        // TakerModule,
        HbsPageItemsModule,
        HbsComponentsModule,

        WowModule.forRoot(),
        SweetAlert2Module.forRoot(),
        DeviceDetectorModule.forRoot()
    ],

    schemas: [NO_ERRORS_SCHEMA],

    /* DECLARATIONS are view classes that belong to this module */
    declarations: [AppComponent,
        // LoadingComponent,
        HomeComponent],

    /* EXPORTS that should be visible and usable in other modules */
    exports: [],

    /* PROVIDERS are creators of services that this module contributes to the global collection of services;
     they become accessible in all parts of the app */
    providers: [

        MDBSpinningPreloader,

        // Logger info is here https://www.npmjs.com/package/angular2-logger
        // from console:
        // Use local storage: logger.store() // and logger.unstore() to undo.
        // Change logger level: logger.level = logger.Level.WARN
        LoggerService,
        {
            provide: LoggerOptions,
            useValue: {level: (IS_PROD ? LoggerLevel.ERROR : LoggerLevel.LOG)}
        },

        {
            provide: Window,
            useValue: window
        },

        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppInterceptor,
            multi: true
        }

    ],

    /* BOOTSTRAP is the main application view */
    bootstrap: [AppComponent]

})

export class AppModule {

    constructor(private store: NgRedux<AppStorageState>,
                private devTools: DevToolsExtension,
                private rootEpic: RootEpic) {

        let enhancers = [];

        if (!environment.production && devTools.isEnabled()) {
            enhancers.push(devTools.enhancer());
        }

        store.configureStore(
            rootReducer,
            initialState,
            [createEpicMiddleware(rootEpic.epic())],
            enhancers);

        // store.dispatch({
        //     type: StoreActionsEnum.APP_INIT
        // });

    }
}
